module.exports = __webpack_public_path__ + "img/ab-page2-img4.b890f7ed.png";